module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
    }],
    staticClass: "create-btn",
    attrs: {
      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>N</span></p>'
    },
    on: {
      "click": _vm.setShowModal
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n  ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showModal) ? _c('AppModal', {
    attrs: {
      "isShowFooter": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.create_absence')))]), _vm._v(" "), _c('div', {
    staticClass: "create-absence__form",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.who')))]), _vm._v(" "), _c('SubsCreateDSelect', {
    attrs: {
      "id": "create_absence_user",
      "items": _vm.users
    },
    on: {
      "update": _vm.setUsers
    }
  }), _vm._v(" "), (!_vm.isUserSelected && _vm.showErrorMessages) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.person_must_be_filled')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
    staticClass: "absence-reason"
  }, [_c('dSelect', {
    attrs: {
      "items": _vm.subsAbsenceReasonsSorted,
      "receiveData": _vm.reasonCreated,
      "multiple": false,
      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason')
    },
    on: {
      "update": _vm.setReason,
      "searchText": _vm.setReasonSearchText,
      "onSearchTextDebounced": _vm.onSearchTextDebounced,
      "enter": function($event) {
        _vm.isCreateAbsenceReason = true
      },
      "close": _vm.onCloseDSelectAbsenceReasons
    }
  }, [_c('div', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [(_vm.userHasPermission('can_manage_absence_reasons')) ? _c('h4', {
    staticClass: "create-absence-link",
    on: {
      "click": function($event) {
        _vm.isCreateAbsenceReason = true
      }
    }
  }, [_vm._v("\n                  + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.reasonSearchText) + "\"\n                ")]) : _c('h4', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                ")])])]), _vm._v(" "), (_vm.userHasPermission('can_manage_absence_reasons') && _vm.isShowCreateAbsenceReasonButton) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
    }],
    staticClass: "icon__bg-circle absence-reasons__settings",
    attrs: {
      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.reasonSearchText + "\" " + _vm.i18n[_vm.locale]["as_a_new_reason"]
    },
    on: {
      "click": function($event) {
        _vm.isCreateAbsenceReason = true
      }
    }
  }, [_c('span', {
    staticClass: "d-icon-plus"
  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.isReasonSelected && _vm.showErrorMessages) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.date')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.getDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  }), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
    staticClass: "absence-no-end-date",
    class: {
      'absence-no-end-date--active': _vm.isAbsenceOngoing
    }
  }, [_c('div', {
    staticClass: "absence-no-end-date__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isAbsenceOngoing = !_vm.isAbsenceOngoing
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : _c('div', {
    staticClass: "absence-no-end-date"
  }, [_c('p', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.cant_be_ongoing_absence')))])])], 1), _vm._v(" "), (_vm.absentUsersWithOngoingAbsenceAlready.length > 0) ? _c('div', {
    staticClass: "do-warning marg-1-top"
  }, [_vm._l((_vm.absentUsersWithOngoingAbsenceAlready), function(user) {
    return _c('b', {
      key: user,
      staticClass: "marg-05-right"
    }, [_vm._v(_vm._s(user) + " ")])
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['already_has_ongoing_absence']) + "\n          ")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "create__form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('div', {
    staticClass: "time-changer__group"
  }, [_c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hint--right",
    attrs: {
      "aria-label": _vm.i18n[_vm.locale]['set_default_start_and_endtime']
    }
  }, [_c('div', {
    staticClass: "icon__bg-circle time-changer__settings",
    on: {
      "click": function($event) {
        _vm.isShowSettings = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-cog2"
  })])])], 1)]), _vm._v(" "), (_vm.isStartDateSameDayAsEndDate) ? _c('div', {
    staticClass: "create__form-group create__form-group__note-to-absence"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['note_to_absence']))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteForAbsentReason),
      expression: "noteForAbsentReason"
    }],
    staticClass: "d-input",
    domProps: {
      "value": (_vm.noteForAbsentReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteForAbsentReason = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'top',
        zIndex: 12312312312312
      }),
      expression: "{\n                    placement : 'top',\n                    zIndex: 12312312312312\n                  }"
    }],
    staticClass: "bttn create-btn right marg-10",
    attrs: {
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.submitUser
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.create_absence')) + "\n          ")])])])]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
    on: {
      "close": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_setting']))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('label', {
    staticClass: "d-input marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['set_default_start_and_endtime']))]), _vm._v(" "), _c('TimeChanger', {
    staticClass: "marg-1-top",
    attrs: {
      "showIcon": true,
      "start": _vm.standardStartTime,
      "end": _vm.standardEndTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStandardStartTime,
      "updateEnd": _vm.setStandardEndTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn bttn-simple marg-1-right",
    on: {
      "click": function($event) {
        _vm.isShowSettings = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.submitStandardSettings
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
    attrs: {
      "initTitle": _vm.reasonSearchText,
      "reasons": _vm.subsAbsenceReasonsSorted
    },
    on: {
      "create": _vm.createAbsenceReason,
      "cancel": function($event) {
        _vm.isCreateAbsenceReason = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea006af8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsCreate.vue
// module id = 1769
// module chunks = 1